module.exports = __webpack_public_path__ + "img/recharge-copy-4.b0055c1.svg";